import DataLayerService from "../../DataLayerService.js";
export { createDialogViewParams };

const dataLayerService = new DataLayerService();

window.addEventListener('DOMContentLoaded', observeAllDialogs);

function observeAllDialogs() {
  const config = {
    attributes: true,
    childList: true,
    subtree: true
  };
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      const mutationOccuredOnOpenDialog = mutation.target && mutation.target.nodeName === "DIALOG" && mutation.target.open === true;
      const mutationOccuredOnCloseDialog = mutation.target && mutation.target.nodeName === "DIALOG" && mutation.target.open === false;
      const observedAttributes = ["open", "dl-name"];
      if (mutationOccuredOnOpenDialog && observedAttributes.includes(mutation.attributeName)) {
        handleOpenEvent(mutation.target);
      }
      if (mutationOccuredOnCloseDialog && observedAttributes.includes(mutation.attributeName)) {
        handleCloseEvent(mutation.target);
      }
    })
  });
  observer.observe(document.body, config);
}

function handleOpenEvent(dialog) {
  const params = createDialogViewParams(dialog);
  dataLayerService.pushEvent("dialog_view", params);
}

function handleCloseEvent(dialog) {
  const params = createDialogCloseParams(dialog);
  dataLayerService.pushEvent("dialog_close", params);
}

function createDialogViewParams(dialog) {
  return {
    dialog_name: dialog.getAttribute("dl-name"),
    component: dialog.closest("[component]")?.getAttribute("component")
  };
}

function createDialogCloseParams(dialog) {
  return {
    dialog_name: dialog.getAttribute("dl-name"),
    component: dialog.closest("[component]")?.getAttribute("component")
  };
}
